import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const FinanceStatutory = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Company Information',
      desc: 'Company Details, EAP and Industry Norm',
      onClick: () => navigate('/finance-statutory/company-information'),
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
    },
    {
      label: 'Financial Statements',
      desc: 'Upload and manage financial documents',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
    },
    {
      label: 'Documentation Upload',
      desc: 'Upload supporting documents for statutory compliance',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <polyline points="9 12 11 14 15 10"/>
        </svg>
      ),
    },
    {
      label: 'Manage NPAT',
      desc: 'Manage NPAT for ESD and SED Targets',
      onClick: () => navigate('/finance-statutory/npat'),
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M20 12V8H4a2 2 0 0 1 0-4h16v4"/>
          <path d="M4 8h16v12H4z"/>
          <circle cx="16" cy="14" r="1"/>
        </svg>
      ),
    },
    {
      label: 'Manage TMPS',
      desc: 'Manage inclusions and Exclusions for Procurement',
      onClick: () => navigate('/finance-statutory/manage-tmps'),
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M20 12V8H4a2 2 0 0 1 0-4h16v4"/>
          <path d="M4 8h16v12H4z"/>
          <circle cx="16" cy="14" r="1"/>
        </svg>
      ),
    },
    {
      label: 'Templates & Resources',
      desc: 'Financial and statutory compliance templates and guides',
      icon: (
        <svg viewBox="0 0 24 24">
          <polyline points="17 1 21 5 17 9"/>
          <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
          <polyline points="7 23 3 19 7 15"/>
          <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
        </svg>
      ),
    },
    {
      label: 'Audited Reports',
      nClick: () => navigate('/finance-statutory/documentation/'),
      desc: 'View and upload audited financials',
      icon: (
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
      ),
    },
    {
      label: 'CIPC Registration',
      desc: 'Company registration details',
      icon: (
        <svg viewBox="0 0 24 24">
          <rect x="2" y="7" width="20" height="14" rx="2"/>
          <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
        </svg>
      ),
    },
    {
      label: 'Compliance Status',
      desc: 'Overall statutory compliance overview',
      icon: (
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      ),
    },
  ];

  return (
    <DashboardPage
      theme="finance"
      title="Finance & Statutory"
      subtitle="B-BBEE Scorecard — Finance & Statutory Element"
      actions={actions}
    />
  );
};

export default FinanceStatutory;
